"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSUPPORTED_MATCHER_TYPE = exports.NOT_IN_SPLIT = exports.SPLIT_ARCHIVED = exports.EXCEPTION = exports.SDK_NOT_READY = exports.SPLIT_NOT_FOUND = exports.NO_CONDITION_MATCH = exports.SPLIT_KILLED = void 0;
exports.SPLIT_KILLED = 'killed';
exports.NO_CONDITION_MATCH = 'default rule';
exports.SPLIT_NOT_FOUND = 'definition not found';
exports.SDK_NOT_READY = 'not ready';
exports.EXCEPTION = 'exception';
exports.SPLIT_ARCHIVED = 'archived';
exports.NOT_IN_SPLIT = 'not in split';
exports.UNSUPPORTED_MATCHER_TYPE = 'targeting rule type unsupported by sdk';
